import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    vecona: [],
    totalesVecona: [],
  },
  mutations: {

    getVecona(state, datos) {
      state.vecona = datos;
    },

    getTotalesVecona(state, datos) {
      state.totalesVecona = datos;
    },

    destroyVecona(state) {
      state.vecona = [];
      state.totalesVecona = [];
    },
  },
  actions: {
    async getVecona({
      commit,
    }, vec) {
      try {
        const res = await api.getVecona(vec);
        // console.log(object);
        if (res.data.INFO.cod === '200') {
          commit('getVecona', res.data.DATOS);
          return [true, res.data.INFO.paginacion.Paginas];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async getTotalesVecona({
      commit,
    },objVec) {
      try {
        const res = await api.getTotalesVecona(objVec);
        // console.log(object);
        if (res.data.INFO.cod === '200') {
          commit('getTotalesVecona', res.data.INFO.Totales);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async updateConciliacion({
      commit,
    }, vec) {
      try {
        const res = await api.updateConciliacion(vec);
        // console.log(object);
        if (res.data.INFO.cod === '200') {
          //commit('updateConciliacion', res.data.DATOS);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },


    async destroyVecona({ commit }) {
      commit('destroyVecona');
    },




  },
};
